import { useSelector } from 'react-redux';

import type { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';

import { selectCurrentPage } from '../selectors/currentPage';

export const useCurrentPage = (): number =>
  useSelector<SpartacuxProductDiscoveryDomainState, number>(selectCurrentPage);
